import React from 'react'
import {  useTranslation } from 'react-i18next';
import {MwInputText, MwTextArea} from '../../ui/';
import CardAmount from '../../ui/CardAmount';
import PromoCodeBox from '../PromoCodeBox';
import TagList from '../../ui/TagList';
import {amountFormat} from '../../../utils/invoceHelper';

const InvFormFooter = ({
    invNotes,
    setInvNotes,
    invTotalAmount,
    totalAmountWithDiscount,
    promoCode,
    setPromoCode,
    discount,
    vat,
    netTotal,
    havePromoCode,
    setHavePromoCode,
    promoCodeHandler,
    discountOnchange,
    SETTING_PRICE_INCLUDE_VAT,
    SETTING_INV_CURRENCY,
    tagList,
    setTagList,
    disabledDiscount,
    formatter,
    formatWithCurrency,
    selectedCurrency
}) => {
    const [t] = useTranslation('global')
    console.log('footer => totalAmountWithDiscount',totalAmountWithDiscount)
    return (
        <div id='footer-inv' className='flex flex-col gap-6'>
        {/* <MwTextArea 
            placeholder={t('invoice.enterNotes')}
            value={invNotes}
            onChange={(e)=>setInvNotes(e.target.value)}
            /> */}
   

        <div className='flex flex-col lg:flex-row gap-6 items-start justify-between'>
            {/* First Row */}
            <div className='flex-1 w-full'>
                <div className='grid grid-cols-3 gap-4'>
                    <div className=''>
                        <CardAmount
                            label= {t("quotes.totalBeforeDiscount")}
                            amountValue={formatWithCurrency(invTotalAmount ,selectedCurrency,formatter, amountFormat)}
                        />
                    </div>
                    <div className=''>
                        <div className='text-center'>
                            <div className='text-[#251658]  text-xs uppercase tracking-wider mb-1'>{t("quotes.totalOnDiscount")}</div>
                            <MwInputText
                                value={discount}
                                disabled={true}
                                classNameInput = 'font-bold text-gray-600 !text-[16px] text-center  py-3'
                                size='sm'
                                onChange={(e)=>discountOnchange(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className=''>
                        <CardAmount
                            label= {t("quotes.totalAfterDiscount")}
                            amountValue={ formatWithCurrency(totalAmountWithDiscount,selectedCurrency,formatter, amountFormat) }
                        />
                    </div>
                </div>
            </div>

            {/* Second Row */}
            <div className='flex-1 w-full'>
                <div className='grid grid-cols-2 gap-4'>
                    <div className=''>
                        <CardAmount
                            label={t('invoice.vatAmount')}
                            amountValue={formatWithCurrency(vat ,selectedCurrency,formatter, amountFormat)}
                        />
                    </div>
                    <div className=''>
                        <div className='text-center'>
                            <h4 className='text-[#251658] text-center text-sm uppercase '>{t('invoice.netTotal')}</h4>
                            <CardAmount
                                label=""
                                amountValue={formatWithCurrency(netTotal ,selectedCurrency,formatter, amountFormat)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
{/*                  
        <div className='pt-2 flex flex-col justify-center items-center'>
            { SETTING_PRICE_INCLUDE_VAT === 'true' ?
                <div className='flex justify-center items-center text-xs text-slate-400 '>{t('invoice.priceIncludesVat')}</div> : 
                <div className='text-xs text-slate-400 text-center'>{t('invoice.priceNotIncludesVat')}</div> 
                
            }
        </div> */}
    </div>
    )
}

export default InvFormFooter